import { Link } from 'react-router-dom';
import styles from '../styles/Home.module.css';

function Home() {
    return (
        <div className={styles.home}>
            <section className={styles.hero}>
                <h1>Welcome</h1>
                <p className={styles.tagline}>
                    Software Engineer specializing in clean architecture, type-safe design, and
                    scalable systems
                </p>
                <div className={styles.cta}>
                    <Link to="/blog" className={styles.primaryButton}>
                        Read Blog
                    </Link>
                    <Link to="/about" className={styles.secondaryButton}>
                        Learn More
                    </Link>
                </div>
            </section>

            <section className={styles.highlights}>
                <div className={styles.highlight}>
                    <h2>🏗️ Clean Architecture</h2>
                    <p>
                        Building maintainable systems with clear separation of concerns and modular
                        design
                    </p>
                </div>
                <div className={styles.highlight}>
                    <h2>🔒 Type Safety</h2>
                    <p>
                        Leveraging strong typing to catch errors early and create reliable software
                    </p>
                </div>
                <div className={styles.highlight}>
                    <h2>⚡ Performance</h2>
                    <p>Optimizing for speed with strategic caching and efficient algorithms</p>
                </div>
            </section>
        </div>
    );
}

export default Home;
